module.exports = __webpack_public_path__ + "static/media/taipingshan_package.86974dd7.png";